import React from "react";
import Branding from "./Branding";

export default function index() {
  return (
    <div>
      <Branding />
    </div>
  );
}
